module.exports = __webpack_public_path__ + "img/curtain-right-desktop.cf696fc4.png";